import { Tag } from 'antd'
import { useTranslation } from 'react-i18next'
import type { PaymentStatus, PurchaseState } from './supplierApi'

const STATE_COLOR: Record<PurchaseState, string> = {
  DRAFT: 'default',
  SUBMITTED: 'gold',
  HQ_VERIFIED: 'blue',
  PARTIALLY_RECEIVED: 'cyan',
  RECEIVED: 'green',
  CANCELLED: 'default',
}

const PAYMENT_COLOR: Record<PaymentStatus, string> = {
  UNPAID: 'default',
  PARTIALLY_PAID: 'gold',
  PAID: 'green',
  OVERDUE: 'red',
}

export function PurchaseStateTag({ state }: { state: PurchaseState }) {
  const { t } = useTranslation()
  return <Tag color={STATE_COLOR[state]}>{t(`purchase.state.${state}`)}</Tag>
}

export function PaymentStatusTag({ status }: { status: PaymentStatus | null }) {
  const { t } = useTranslation()
  if (status === null) return <>{t('common.dash')}</>
  return <Tag color={PAYMENT_COLOR[status]}>{t(`purchase.paymentStatus.${status}`)}</Tag>
}
